// BOUD ACTION TYPES
export enum actionTypeEnum{
    UDEU_BOUD_CORRECTION_ACTION_TYPE = "001",
    UDEU_BOUD_MENTION_ACTION_TYPE = "002",
    UDEU_BOUD_MODIFICATION_ACTION_TYPE = "003",
    UDEU_BOUD_SUSPENSION_ACTION_TYPE = "004",
    UDEU_BOUD_REPEAL_ACTION_TYPE = "005",
}